// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"25981": "c1ae581b","38851": "954c66e1","42530": "81999d02","78990": "aa917893","83460": "892a0f60","89066": "47e4a6fa",}[chunkId] + ".css"
}